import React from 'react';
import { ThemeContext } from 'styled-components';
import { theme as defaultTheme } from '.';

const useTheme = () => {
  const theme = React.useContext(ThemeContext);

  return theme || defaultTheme;
};

export default useTheme;
